export default "../../src/img/lysiq-logo-simplified.svg";